import { instance as axios } from '../../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { GetBlackoutPeriod , BlacoutPeriodInsert , GetManualExcercise , 
        PaymentmodeDetail , ManualExerciseSave , GetUserDetailForPayment , EnterPaymentSave , CurrentBatchNO ,
        GetExerciseProcessByDate , ExerciseProcessByBatchNoInfo , EnterListingDetails } from '../../../models/esopOptions';

//================|| ESOP OPTION SLICE ||=================//

type CreateGHrantState = {
    loading: boolean;
    error: ErrorInformation,
    getBlackoutPeriod: GetBlackoutPeriod[];
    getManualExcercise: GetManualExcercise[];
    NewUserResponseMessage: string;
    paymentmodeDetail: PaymentmodeDetail[];
    getUserDetailForPayment: GetUserDetailForPayment[];
    currentBatchNO: CurrentBatchNO;
    ExerciseProcessByDateDetails: GetExerciseProcessByDate[];
    exerciseProcessByBatchNoInfo: ExerciseProcessByBatchNoInfo;
    LetterToCDPMessage: string;
    SummaryOfExerciseMessage: string;
    ApplicationListingMessage: string;
    FormCDPMessage: string;
    CDPTextFileMessage: string;
    Form42Message: string;
    SaveResponse: string;
    enterListingDetails: EnterListingDetails[];
}

type userNameanduserID = {
    searchUserID: string,
    searchName: string,
}

type userNameanduserIDPaymentID = {
    searchUserID: string,
    searchName: string,
    paymentTypeID: string,
}

type FromDateandTodate = {
    fromDate: string,
    toDate: string,
}

type LetterToCDPParams = {
    batchNo: number,
    formTypeID: string,
    sign: number,
    isSubmitted: boolean,
}

type SummaryOfExerciseParams = {
    batchNo: number,
    formTypeID: string,
    sign1: number,
    sign2: number,
    page: number,
    isSubmitted: boolean,
}

type ApplicationListingParams = {
    batchNo: number,
    formTypeID: string,
    alaSign1: number,
    shareCapital: number,
    issuedShares: number,
    agmDate: string,
    isSubmitted: boolean,
}

type FormCDPParams = {
    batchNo: number,
    formTypeID: string,
    isSubmitted: boolean,
}

type Form42Params = {
    batchNo: number,
}

type GenerateBatchParams = {
    batchNo: number,
    batchDate: string,
    type: string,
}

type SubmitBatchParams = {
    batchNo: number,
    isListed: boolean,
    sgxLetterSign: number,
    a1Sign1: number,
    a1Sign2: number,
    alaSign: number,
    latestIssuedShares: number,
    paidUpCapital: number,
}

type AssetValueParams = {
    batchNoList: string,
    listingDate: string,
    listingPrice: number,
}

const initialState: CreateGHrantState = {
    loading: true,
    error: null,
    getBlackoutPeriod: [],
    getManualExcercise: [],
    NewUserResponseMessage: '',
    paymentmodeDetail: [],
    getUserDetailForPayment: [],
    currentBatchNO: {
        batchNo: 0,
        numberOfOption: 0,
        numberOfParticipant: 0,
        unsubmittedBatchInfo: [],
        signature: {
            sxn: [],
            a1: [],
            a2: [],
        },
    },
    ExerciseProcessByDateDetails: [],
    exerciseProcessByBatchNoInfo: {
        paidUpShareCapital: 0,
        ordinaryShares: 0,
        batchNo: 0,
        batchDate: '',
        batchType: '',
        isListed: false,
        options: [],
    },
    LetterToCDPMessage: '',
    SummaryOfExerciseMessage: '',
    ApplicationListingMessage: '',
    FormCDPMessage: '',
    CDPTextFileMessage: '',
    Form42Message: '',
    SaveResponse: '',
    enterListingDetails: [],
};

export const getManageBlackoutPeriod = createAsyncThunk<GetBlackoutPeriod, {}, { rejectValue: ErrorInformation }>(
    "esopoption/getManageBlackoutPeriod",
    async ({ }, { rejectWithValue }) => {
        try {
            const getManageBlackoutPeriodResponse = await axios.get<GetBlackoutPeriod>('Option/getManageBlackoutPeriod')
            return getManageBlackoutPeriodResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const insertBlackoutPeriod = createAsyncThunk<string, { blacoutPeriodInsert: BlacoutPeriodInsert , status }, { rejectValue: ErrorInformation }>(
    "esopoption/insertBlackoutPeriod",
    async ({blacoutPeriodInsert , status}, { rejectWithValue }) => {
        try {
            if(status == 'ADD'){
                const response = await axios.post('/Option/insertBlackoutPeriod', blacoutPeriodInsert)
                return response.data[0];
            } else if(status == 'EDIT') {
                const response = await axios.put('/Option/updateBlackoutPeriod', blacoutPeriodInsert)
                return response.data[0];
            }else if(status == 'DEL') {
                const params = {blackoutPeriodID: blacoutPeriodInsert.blackoutPeriodID};
                const response = await axios.delete('/Option/deleteBlackoutPeriod', {
                    data: params
                  })
                return response.data[0];
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getManualExercise = createAsyncThunk(
    "esopoption/getManualExercise",
    async (userNameanduserID: userNameanduserID, { rejectWithValue }) => {
        try {
            if(userNameanduserID.searchUserID.toString() != '' && 
            userNameanduserID.searchName.toString() != '') {
                const getManualExerciseResponse = await axios.get<GetManualExcercise[]>(`Option/getManualExercise?searchUserID=${userNameanduserID.searchUserID.toString()}&searchName=${userNameanduserID.searchName.toString()}`)
                return getManualExerciseResponse.data
            }
            else if(userNameanduserID.searchUserID.toString() != '') {
                const getManualExerciseResponse = await axios.get<GetManualExcercise[]>(`Option/getManualExercise?searchUserID=${userNameanduserID.searchUserID.toString()}`)
                return getManualExerciseResponse.data
            }
            else if(userNameanduserID.searchName.toString() != '') {
                const getManualExerciseResponse = await axios.get<GetManualExcercise[]>(`Option/getManualExercise?searchName=${userNameanduserID.searchName.toString()}`)
                return getManualExerciseResponse.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const setManualExercise = createAsyncThunk<number, { manualExerciseSave: ManualExerciseSave }, { rejectValue: ErrorInformation }>(
    "esopoption/setManualExercise",
    async ({manualExerciseSave}, { rejectWithValue }) => {
        try {
            const response = await axios.post('/Option/setManualExercise', manualExerciseSave)
            return response.data[0];
           
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getPaymentType = createAsyncThunk<PaymentmodeDetail, {}, { rejectValue: ErrorInformation }>(
    "esopoption/getPaymentType",
    async ({ }, { rejectWithValue }) => {
        try {
            const getPaymentTypeResponse = await axios.get<PaymentmodeDetail>('Misc/GetPaymentType');
            return getPaymentTypeResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getEnterPayment = createAsyncThunk(
    "esopoption/getEnterPayment",
    async (Detail: userNameanduserIDPaymentID, { rejectWithValue }) => {
        try {
            if(Detail.searchUserID.toString() != '' && 
            Detail.searchName.toString() != '') {
                const getEnterPaymentResponse = await axios.get<GetUserDetailForPayment[]>(`Option/getEnterPayment?searchUserID=${Detail.searchUserID.toString()}&searchName=${Detail.searchName.toString()}&paymentTypeID=${Detail.paymentTypeID.toString()}`)
                return getEnterPaymentResponse.data
            }
            else if(Detail.searchUserID.toString() != '') {
                const getEnterPaymentResponse = await axios.get<GetUserDetailForPayment[]>(`Option/getEnterPayment?searchUserID=${Detail.searchUserID.toString()}&paymentTypeID=${Detail.paymentTypeID.toString()}`)
                return getEnterPaymentResponse.data
            }
            else if(Detail.searchName.toString() != '') {
                const getEnterPaymentResponse = await axios.get<GetUserDetailForPayment[]>(`Option/getEnterPayment?searchName=${Detail.searchName.toString()}&paymentTypeID=${Detail.paymentTypeID.toString()}`)
                return getEnterPaymentResponse.data
            }
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const setEnterPayment = createAsyncThunk<number, { enterPaymentSave: EnterPaymentSave }, { rejectValue: ErrorInformation }>(
    "esopoption/setEnterPayment",
    async ({enterPaymentSave}, { rejectWithValue }) => {
        try {
            const response = await axios.post('/Option/setEnterPayment', enterPaymentSave)
            return response.data[0];
           
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getCurrentBatchNo = createAsyncThunk<CurrentBatchNO, {}, { rejectValue: ErrorInformation }>(
    "esopoption/getCurrentBatchNo",
    async ({ }, { rejectWithValue }) => {
        try {
            const getCurrentBatchNoResponse = await axios.get<CurrentBatchNO>('Option/getCurrentBatchNo')
            return getCurrentBatchNoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getExerciseProcessByDate = createAsyncThunk(
    "esopoption/getExerciseProcessByDate",
    async (fromDateandTodate: FromDateandTodate, { rejectWithValue }) => {
        try {
            const getExerciseProcessByDateResponse = await axios.get<GetExerciseProcessByDate[]>(`Option/getExerciseProcessByDate?fromDate=${fromDateandTodate.fromDate}&toDate=${fromDateandTodate.toDate}`)
            return getExerciseProcessByDateResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getExerciseProcessByBatchNo = createAsyncThunk(
    "esopoption/getExerciseProcessByBatchNo",
    async (batchNo: number , { rejectWithValue }) => {
        try {
            const getExerciseProcessByBatchNoResponse = await axios.get<ExerciseProcessByBatchNoInfo[]>(`Option/getExerciseProcessByBatchNo?batchNo=${batchNo}`)
            return getExerciseProcessByBatchNoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getLetterToCDP = createAsyncThunk(
    "esopoption/getLetterToCDP",
    async (letterToCDPParams: LetterToCDPParams, { rejectWithValue }) => {
        try {
            const performanceAwardLetterResponse = await axios.get<string>(`Option/getLetterToCDP?batchNo=${letterToCDPParams.batchNo}&formTypeID=${letterToCDPParams.formTypeID}
                &sign=${letterToCDPParams.sign}&isSubmitted=${letterToCDPParams.isSubmitted}`)
            return performanceAwardLetterResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getSummaryofParticularofExercise = createAsyncThunk(
    "esopoption/getSummaryofParticularofExercise",
    async (summaryOfExerciseParams: SummaryOfExerciseParams, { rejectWithValue }) => {
        try {
            const getSummaryofParticularofExerciseResponse = await axios.get<string>(`Option/getSummaryofParticularofExercise?batchNo=${summaryOfExerciseParams.batchNo}&formTypeID=${summaryOfExerciseParams.formTypeID}
                &sign1=${summaryOfExerciseParams.sign1}&sign2=${summaryOfExerciseParams.sign2}&page=${summaryOfExerciseParams.page}&isSubmitted=${summaryOfExerciseParams.isSubmitted}`)
            return getSummaryofParticularofExerciseResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getApplicationForListing = createAsyncThunk(
    "esopoption/getApplicationForListing",
    async (applicationListingParams: ApplicationListingParams, { rejectWithValue }) => {
        try {
            const getApplicationForListingResponse = await axios.get<string>(`Option/getApplicationForListing?batchNo=${applicationListingParams.batchNo}&formTypeID=${applicationListingParams.formTypeID}
                &alaSign1=${applicationListingParams.alaSign1}&shareCapital=${applicationListingParams.shareCapital}&issuedShares=${applicationListingParams.issuedShares}
                &agmDate=${applicationListingParams.agmDate}&isSubmitted=${applicationListingParams.isSubmitted}`)
            return getApplicationForListingResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getFormCDP = createAsyncThunk(
    "esopoption/getFormCDP",
    async (formCDPParams: FormCDPParams, { rejectWithValue }) => {
        try {
            const getFormCDPResponse = await axios.get<string>(`Option/getFormCDP?batchNo=${formCDPParams.batchNo}&formTypeID=${formCDPParams.formTypeID}
                &isSubmitted=${formCDPParams.isSubmitted}`)
            return getFormCDPResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getCDPTextFile = createAsyncThunk(
    "esopoption/getCDPTextFile",
    async (formCDPParams: FormCDPParams, { rejectWithValue }) => {
        try {
            const getCDPTextFileResponse = await axios.get<string>(`Option/getCDPTextFile?batchNo=${formCDPParams.batchNo}&formTypeID=${formCDPParams.formTypeID}
                &isSubmitted=${formCDPParams.isSubmitted}`)
            return getCDPTextFileResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const GetForm42XML = createAsyncThunk(
    "esopoption/GetForm42XML",
    async (form42Params: Form42Params, { rejectWithValue }) => {
        try {
            const GetForm42XMLResponse = await axios.get<string>(`Option/GetForm42XML?batchNo=${form42Params.batchNo}`)
            return GetForm42XMLResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setExerciseProcessReSubmit = createAsyncThunk(
    "esopoption/setExerciseProcessReSubmit",
    async (batchNo: string, { rejectWithValue }) => {
        try {
            const setExerciseProcessReSubmitResponse = await axios.post<string>(`Option/setExerciseProcessReSubmit?batchNo=${batchNo}`)
            return setExerciseProcessReSubmitResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const DeleteExerciseProcessBatch = createAsyncThunk(
    "esopoption/DeleteExerciseProcessBatch",
    async (batchNo: string, { rejectWithValue }) => {
        try {
            const DeleteExerciseProcessBatchResponse = await axios.delete<string>(`Option/DeleteExerciseProcessBatch?batchNo=${batchNo}`)
            return DeleteExerciseProcessBatchResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setExerciseProcessDraft = createAsyncThunk(
    "esopoption/setExerciseProcessDraft",
    async (generateBatchParams: GenerateBatchParams, { rejectWithValue }) => {
        try {
            const setExerciseProcessDraftResponse = await axios.post<string>(`Option/setExerciseProcessDraft?batchNo=${generateBatchParams.batchNo}
                &batchDate=${generateBatchParams.batchDate}&type=${generateBatchParams.type}`)
            return setExerciseProcessDraftResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setExerciseProcessSubmit = createAsyncThunk(
    "esopoption/setExerciseProcessSubmit",
    async (submitBatchParams: SubmitBatchParams, { rejectWithValue }) => {
        try {
            const setExerciseProcessSubmitResponse = await axios.post<string>(`Option/setExerciseProcessSubmit?batchNo=${submitBatchParams.batchNo}
                &isListed=${submitBatchParams.isListed}&sgxLetterSign=${submitBatchParams.sgxLetterSign}&a1Sign1=${submitBatchParams.a1Sign1}
                &a1Sign2=${submitBatchParams.a1Sign2}&alaSign=${submitBatchParams.alaSign}&latestIssuedShares=${submitBatchParams.latestIssuedShares}
                &paidUpCapital=${submitBatchParams.paidUpCapital}`)
            return setExerciseProcessSubmitResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const getListingDateBatchNo = createAsyncThunk<GetBlackoutPeriod, {}, { rejectValue: ErrorInformation }>(
    "esopoption/getListingDateBatchNo",
    async ({ }, { rejectWithValue }) => {
        try {
            const getListingDateBatchNoResponse = await axios.get<GetBlackoutPeriod>('Option/getListingDateBatchNo')
            return getListingDateBatchNoResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)

export const setListingDate = createAsyncThunk(
    "esopoption/setListingDate",
    async (assetValueParams: AssetValueParams, { rejectWithValue }) => {
        try {
            const setListingDateResponse = await axios.post<string>(`Option/setListingDate?batchNoList=${assetValueParams.batchNoList}
                &listingDate=${assetValueParams.listingDate}&listingPrice=${assetValueParams.listingPrice}`)
            return setListingDateResponse.data[0];
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)


//================|| ESOP OPTION EXERCISE PROCESS SLICE ||=================//

const esopoptionSlice = createSlice({
    name: 'esopoption',
    initialState,
    reducers: {},
    extraReducers: {

        // get Blackout Period
        [getManageBlackoutPeriod.pending.type]: (state) => {
            state.loading = true;
        },
        [getManageBlackoutPeriod.fulfilled.type]: (state, action) => {
            state.getBlackoutPeriod = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getManageBlackoutPeriod.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Blackout Period Insert
        [insertBlackoutPeriod.pending.type]: (state) => {
            state.loading = true;
        },
        [insertBlackoutPeriod.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [insertBlackoutPeriod.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // ESOP - Option - Manual Excercise User Details
        [getManualExercise.pending.type]: (state) => {
            state.loading = true;
        },
        [getManualExercise.fulfilled.type]: (state, action) => {
            state.getManualExcercise = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getManualExercise.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        //get Payment Mode View
        [getPaymentType.pending.type]: (state) => {
            state.loading = true;
        },
        [getPaymentType.fulfilled.type]: (state, action) => {
            state.paymentmodeDetail = action.payload;
            state.loading = false;
        },
        [getPaymentType.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        // Save ESOP - Option - Manual Excercise
        [setManualExercise.pending.type]: (state) => {
            state.loading = true;
        },
        [setManualExercise.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [setManualExercise.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // ESOP - Option - Enter Payment User Details
        [getEnterPayment.pending.type]: (state) => {
            state.loading = true;
        },
        [getEnterPayment.fulfilled.type]: (state, action) => {
            state.getUserDetailForPayment = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getEnterPayment.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // Save ESOP - Option - Enter Payment
        [setEnterPayment.pending.type]: (state) => {
            state.loading = true;
        },
        [setEnterPayment.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.NewUserResponseMessage = action.payload
            state.loading = false;
            state.error = null;
        },
        [setEnterPayment.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // get Current BatchNo Info
        [getCurrentBatchNo.pending.type]: (state) => {
            state.loading = true;
        },
        [getCurrentBatchNo.fulfilled.type]: (state, action) => {
            state.currentBatchNO = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getCurrentBatchNo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // get Exercise Process by Date
        [getExerciseProcessByDate.pending.type]: (state) => {
            state.loading = true;
        },
        [getExerciseProcessByDate.fulfilled.type]: (state, action) => {
            state.ExerciseProcessByDateDetails = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getExerciseProcessByDate.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // get Exercise Process by Batch No.
        [getExerciseProcessByBatchNo.pending.type]: (state) => {
            state.loading = true;
        },
        [getExerciseProcessByBatchNo.fulfilled.type]: (state, action) => {
            state.exerciseProcessByBatchNoInfo = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getExerciseProcessByBatchNo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        //get Letter To CDP detail
        [getLetterToCDP.pending.type]: (state) => {
            state.loading = true;
        },
        [getLetterToCDP.fulfilled.type]: (state, action) => {
            state.LetterToCDPMessage = action.payload;
            state.loading = false;
        },
        [getLetterToCDP.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //get Summary Of Exercise detail
        [getSummaryofParticularofExercise.pending.type]: (state) => {
            state.loading = true;
        },
        [getSummaryofParticularofExercise.fulfilled.type]: (state, action) => {
            state.SummaryOfExerciseMessage = action.payload;
            state.loading = false;
        },
        [getSummaryofParticularofExercise.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //get Application Listing detail
        [getApplicationForListing.pending.type]: (state) => {
            state.loading = true;
        },
        [getApplicationForListing.fulfilled.type]: (state, action) => {
            state.ApplicationListingMessage = action.payload;
            state.loading = false;
        },
        [getApplicationForListing.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //get Form CDP detail
        [getFormCDP.pending.type]: (state) => {
            state.loading = true;
        },
        [getFormCDP.fulfilled.type]: (state, action) => {
            state.FormCDPMessage = action.payload;
            state.loading = false;
        },
        [getFormCDP.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //get CDP Text File detail
        [getCDPTextFile.pending.type]: (state) => {
            state.loading = true;
        },
        [getCDPTextFile.fulfilled.type]: (state, action) => {
            state.CDPTextFileMessage = action.payload;
            state.loading = false;
        },
        [getCDPTextFile.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
        
        //get Form 42 detail
        [GetForm42XML.pending.type]: (state) => {
            state.loading = true;
        },
        [GetForm42XML.fulfilled.type]: (state, action) => {
            state.Form42Message = action.payload;
            state.loading = false;
        },
        [GetForm42XML.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // ReSubmit Batch
        [setExerciseProcessReSubmit.pending.type]: (state) => {
            state.loading = true;
        },
        [setExerciseProcessReSubmit.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setExerciseProcessReSubmit.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Submit Batch
        [setExerciseProcessSubmit.pending.type]: (state) => {
            state.loading = true;
        },
        [setExerciseProcessSubmit.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setExerciseProcessSubmit.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Delete Batch
        [DeleteExerciseProcessBatch.pending.type]: (state) => {
            state.loading = true;
        },
        [DeleteExerciseProcessBatch.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [DeleteExerciseProcessBatch.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // Generate Batch
        [setExerciseProcessDraft.pending.type]: (state) => {
            state.loading = true;
        },
        [setExerciseProcessDraft.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setExerciseProcessDraft.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

        // get Enter Listing Detail
        [getListingDateBatchNo.pending.type]: (state) => {
            state.loading = true;
        },
        [getListingDateBatchNo.fulfilled.type]: (state, action) => {
            state.enterListingDetails = action.payload;
            state.loading = false;
            state.error = null;
        },
        [getListingDateBatchNo.rejected.type]: (state, action: PayloadAction<any | null>) => {
            state.loading = false;
            state.error = action.payload;
        },
        
        // Enter Listing Save
        [setListingDate.pending.type]: (state) => {
            state.loading = true;
        },
        [setListingDate.fulfilled.type]: (state, action: PayloadAction<string | ''>) => {
            state.SaveResponse = action.payload
            state.loading = false;
            state.error = null;
        },
        [setListingDate.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload;
        },

    }
})

export default esopoptionSlice